import {
  Card,
  DataDisplay,
  Grid,
  GridBreak,
  Stack,
  Typography,
  formatPercentTotal,
  getSpacing,
  pn,
} from "@compass/core";
import { Input } from "components";
import { PieChart } from "devextreme-react";
import { Connector, Export, Label, Series, Size } from "devextreme-react/pie-chart";
import { AprEtsTabIVC as AprResponseModel, ModelPropertyBase } from "generated/openApi";

import "moment-timezone";

export const AprEtsTabIVC = (props: {
  data: AprResponseModel | undefined;
  totalTabA: number | undefined;
  properties: ModelPropertyBase[] | undefined;
}) => {
  return (
    <Card style={{ height: "100%" }}>
      <Stack spacing="sm" direction="column" style={{ height: "100%" }}>
        <Typography variant="h5">Postsecondary Education Enrollment</Typography>

        <Grid container spacing="lg">
          <Grid item xs={12}>
            <Grid container spacing="sm" direction="row">
              <Grid item xs={3}></Grid>
              <Grid item xs={2} style={{ alignContent: "center" }}>
                <Typography variant="h6" style={{ textAlign: "center" }}>
                  Enrolled in PSE or Notified of Deferred Enrollment
                </Typography>
              </Grid>
              <Grid item xs={1}></Grid>
              <Grid item xs={2} style={{ alignContent: "center" }}>
                <Typography variant="h6" style={{ textAlign: "center" }}>
                  No Evidence of Enrollment or Deferred Enrollment
                </Typography>
              </Grid>
              <Grid item xs={1}></Grid>
              <Grid item xs={2} style={{ alignContent: "center" }}>
                <Typography variant="h6" style={{ textAlign: "center" }}>
                  Total
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          {/* Row 1 */}
          <Grid item xs={12}>
            <Grid container spacing="sm" direction="row">
              <Grid item xs={3}>
                <Typography variant="caption">
                  1. Received Regular Secondary School Diploma Within Standard Number of Years but Did Not Complete a
                  Rigorous Program of Study
                </Typography>
              </Grid>

              {props.data?.nscCode1 != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center" }} variant="body1">
                    {props.data.nscCode1}
                  </Typography>
                </Grid>
              )}

              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography style={{ textAlign: "center" }} variant="h5">
                  +
                </Typography>
              </Grid>

              {props.data?.noNscCode1 != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.noNscCode1}
                  </Typography>
                </Grid>
              )}

              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography style={{ textAlign: "center" }} variant="h5">
                  =
                </Typography>
              </Grid>

              {props.data?.nscCode1 != null && props.data?.noNscCode1 != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.noNscCode1 + props.data.nscCode1}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Grid>

          {/* Row 2 */}
          <Grid item xs={12} style={{ background: "#f5f5f5"}}>
            <Grid container spacing="sm" direction="row">
              <Grid item xs={3}>
                <Typography variant="caption">
                  2. Received Regular Secondary School Diploma Within Standard Number of Years and Completed a Rigorous
                  Program of Study
                </Typography>
              </Grid>

              {props.data?.nscCode2 != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.nscCode2}
                  </Typography>
                </Grid>
              )}

              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography style={{ textAlign: "center" }} variant="h5">
                  +
                </Typography>
              </Grid>

              {props.data?.noNscCode2 != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.noNscCode2}
                  </Typography>
                </Grid>
              )}

              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography style={{ textAlign: "center" }} variant="h5">
                  =
                </Typography>
              </Grid>

              {props.data?.nscCode2 != null && props.data?.noNscCode2 != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.noNscCode2 + props.data.nscCode2}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Grid>

          {/* Row 1 + 2 */}
          <Grid item xs={12}>
            <Grid container spacing="sm" direction="row">
              <Grid item xs={3}>
                <Typography variant="h6">Total (1 + 2)</Typography>
              </Grid>

              {props.data?.nscCode1And2 != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.nscCode1And2}
                  </Typography>
                </Grid>
              )}

              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography style={{ textAlign: "center" }} variant="h5">
                  +
                </Typography>
              </Grid>

              {props.data?.noNscCode1And2 != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.noNscCode1And2}
                  </Typography>
                </Grid>
              )}

              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography style={{ textAlign: "center" }} variant="h5">
                  =
                </Typography>
              </Grid>

              {props.data?.nscCode1And2 != null && props.data?.noNscCode1And2 != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.noNscCode1And2 + props.data.nscCode1And2}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Grid>

          {/* Row 3 */}
          <Grid item xs={12} style={{ background: "#f5f5f5"}}>
            <Grid container spacing="sm" direction="row">
              <Grid item xs={3}>
                <Typography variant="caption">
                  3. Received a Regular Secondary School Diploma but Not Within the Standard Number of Years
                </Typography>
              </Grid>

              {props.data?.nscCode3 != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.nscCode3}
                  </Typography>
                </Grid>
              )}

              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography style={{ textAlign: "center" }} variant="h5">
                  +
                </Typography>
              </Grid>

              {props.data?.noNscCode3 != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.noNscCode3}
                  </Typography>
                </Grid>
              )}

              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography style={{ textAlign: "center" }} variant="h5">
                  =
                </Typography>
              </Grid>

              {props.data?.nscCode3 != null && props.data?.noNscCode3 != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.noNscCode3 + props.data.nscCode3}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Grid>

          {/* Row 4 */}
          <Grid item xs={12}>
            <Grid container spacing="sm" direction="row">
              <Grid item xs={3}>
                <Typography variant="caption">
                  4. Received an Alternative Credential (e.g., Certificate of Attendance or a High School Equivalency
                  Certificate)
                </Typography>
              </Grid>

              {props.data?.nscCode4 != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.nscCode4}
                  </Typography>
                </Grid>
              )}

              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography style={{ textAlign: "center" }} variant="h5">
                  +
                </Typography>
              </Grid>

              {props.data?.noNscCode4 != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.noNscCode4}
                  </Typography>
                </Grid>
              )}

              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography style={{ textAlign: "center" }} variant="h5">
                  =
                </Typography>
              </Grid>

              {props.data?.nscCode4 != null && props.data?.noNscCode4 != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.noNscCode4 + props.data.nscCode4}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Grid>

          {/* Row 5 */}
          <Grid item xs={12} style={{ background: "#f5f5f5"}}>
            <Grid container spacing="sm" direction="row">
              <Grid item xs={3}>
                <Typography variant="caption">
                  5. Neither Graduated High School nor Received an Alternative Credential
                </Typography>
              </Grid>

              {props.data?.nscCode5 != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.nscCode5}
                  </Typography>
                </Grid>
              )}

              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography style={{ textAlign: "center" }} variant="h5">
                  +
                </Typography>
              </Grid>

              {props.data?.noNscCode5 != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.noNscCode5}
                  </Typography>
                </Grid>
              )}

              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography style={{ textAlign: "center" }} variant="h5">
                  =
                </Typography>
              </Grid>

              {props.data?.nscCode5 != null && props.data?.noNscCode5 != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.noNscCode5 + props.data.nscCode5}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Grid>

          {/* Row 3 + 4 + 5 */}
          <Grid item xs={12}>
            <Grid container spacing="sm" direction="row">
              <Grid item xs={3}>
                <Typography variant="h6">Total (3 + 4 + 5)</Typography>
              </Grid>

              {props.data?.nscCode3And4And5 != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.nscCode3And4And5}
                  </Typography>
                </Grid>
              )}

              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography style={{ textAlign: "center" }} variant="h5">
                  +
                </Typography>
              </Grid>

              {props.data?.noNscCode3And4And5 != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.noNscCode3And4And5}
                  </Typography>
                </Grid>
              )}

              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography style={{ textAlign: "center" }} variant="h5">
                  =
                </Typography>
              </Grid>

              {props.data?.nscCode3And4And5 != null && props.data?.noNscCode3And4And5 != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.noNscCode3And4And5 + props.data.nscCode3And4And5}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Grid>

          {/* Grand Total */}
          <Grid item xs={12} style={{ background: "#f5f5f5"}}>
            <Grid container spacing="sm" direction="row">
              <Grid item xs={3}>
                <Typography variant="h6">Total (1-5)</Typography>
              </Grid>

              {props.data?.totalParticipantsNsc != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.totalParticipantsNsc}
                  </Typography>
                </Grid>
              )}

              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography style={{ textAlign: "center" }} variant="h5">
                  +
                </Typography>
              </Grid>

              {props.data?.totalParticipantsNoNsc != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.totalParticipantsNoNsc}
                  </Typography>
                </Grid>
              )}

              <Grid item xs={1} style={{ alignContent: "center" }}>
                <Typography style={{ textAlign: "center" }} variant="h5">
                  =
                </Typography>
              </Grid>

              {props.data?.totalParticipantsNsc != null && props.data?.totalParticipantsNoNsc != null && (
                <Grid item xs={2} style={{ alignContent: "center" }}>
                  <Typography style={{ textAlign: "center", alignContent: "center" }} variant="body1">
                    {props.data.totalParticipantsNoNsc + props.data.totalParticipantsNsc}
                  </Typography>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Stack>
    </Card>
  );
};
